module.exports = __webpack_public_path__ + "img/29.e68b9a41.jpg";